import { IconButton, List, ListItem, SvgIcon, Tooltip, useTheme } from '@mui/material';
import { LogOut, SwitchHorizontal01 } from '../../../../../assets';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { UserContext } from '../../../../shared/useUser';
import { DrawerNavItem } from '../../interfaces/DrawerNavItem';
import { NavItem } from '../NavItem';
import LanguageSelector from '../../../../../pages/Dashboard/components/LanguageSelector';

interface UserNavItemsListProps {
  variant?: 'default' | 'iconColumn',
  logOutOnClick: () => void,
  switchStoreOnClick: () => void;
}

export const UserNavItemsList = ({ variant, logOutOnClick, switchStoreOnClick }: UserNavItemsListProps) => {
  const theme = useTheme();
  const { t } = useTranslation('drawer');
  const { user } = useContext(UserContext);

  const userNavItems: DrawerNavItem[] = [
    {
      canRender: true,
      translationKey: 'switchStore',
      icon: <SwitchHorizontal01 />,
      onClick: switchStoreOnClick,
      tooltipText: 'selectStore',
    },
    {
      canRender: true,
      translationKey: '',
      icon: <LanguageSelector onLanguageSet={() => { }} />,
      variant: 'customIcon',
    },
    {
      canRender: true,
      translationKey: 'logOut',
      icon: <LogOut />,
      onClick: logOutOnClick,
      tooltipText: 'logOut',
    },
  ];

  const renderIconColumn = (item: DrawerNavItem) => (
    <ListItem key={item.translationKey}
      sx={{
        padding: 0,
        margin: 0,
        backgroundColor: 'transparent',
      }}
    >
      <Tooltip title={t(`${item.tooltipText}`)}>
        <IconButton onClick={item.onClick}
          sx={{ color: 'common.white' }}
        >
          <SvgIcon
            key={`user-nav-item-${item.translationKey}`}
            sx={{
              fontSize: 16,
              cursor: 'pointer',
            }}
            htmlColor={theme.palette.primary.contrastText}>
            {item.icon}
          </SvgIcon>
        </IconButton>
      </Tooltip>
    </ListItem>);

  const renderItem = (item: DrawerNavItem) => {
    switch (variant) {
      case 'iconColumn':
        return renderIconColumn(item);
      case 'default':
      default:
        return <NavItem 
          key={`nav-item-${item.translationKey}`} 
          item={item}
          onClick={item.onClick} />;
    }
  };

  return (
    <List sx={{
      marginTop: '16px',
      marginBottom: '16px',
      padding: '0',
    }}
    >
      {(user?.stores ?? []).length === 1 
        ? userNavItems.filter(item => item.translationKey !== 'switchStore')
          .map((item) => renderItem(item)) 
        : userNavItems.map((item) => renderItem(item))}
    </List>);
};